import {useEffect, useState} from 'react'

import Cards from 'react-credit-cards-2'

import Button from '../../button/Button.jsx'
import {Box, Snackbar, TextField} from '@mui/material'

import {
    general as textsGeneral
} from '../../../translate/Translate.jsx'

import {getSession, setSession} from '../../../hooks/useStorage/useStorage.jsx'
import {isDebug, isEmpty, maskCard, maskDate} from 'react-lf-tools'
import creditCardType from 'credit-card-type'

import {motion} from 'framer-motion'

import 'react-credit-cards-2/dist/lib/styles.scss'
import './addCardCredit.scss'

/*
    REDE
    affiliation: 67493617
    token: d19c9285dd954633aa3bd323bd92aa73

    Number: 5448 2800 0000 0007
    Expiry: 11/30
    Cvc: 123
*/

const AddCardCredit = ({onClick}) => {
    const [cardData, setCardData] = useState({
        name: isDebug('5173') ? 'Felipe' : '',
        number: isDebug('5173') ? '5448 2800 0000 0007' : '',
        expiry: isDebug('5173') ? '11/30' : '',
        cvc: isDebug('5173') ? '123' : ''
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })

    const handleInput = (event) => {
        const {name, value} = event.target
        if (name === 'name') {
            setCardData({...cardData, name: value.toUpperCase()})
        } else if (name === 'number') {
            setCardData({...cardData, number: maskCard(value.substring(0, 20))})
        } else if (name === 'expiry') {
            setCardData({...cardData, expiry: maskDate(value.substring(0, 5))})
        } else if (name === 'cvc') {
            setCardData({...cardData, cvc: value.substring(0, 4)})
        }
    }

    const handleConfirm = () => {
        if (!cardData.name) return setSnackbar({
            open: true,
            message: textsGeneral.invalidName
        })
        if (!cardData.number) return setSnackbar({
            open: true,
            message: textsGeneral.invalidNumber
        })
        if (!cardData.expiry) return setSnackbar({
            open: true,
            message: textsGeneral.invalidDate
        })
        if (!cardData.cvc) return setSnackbar({
            open: true,
            message: textsGeneral.invalidCvc
        })

        const s = cardData.expiry.split('/')
        const card = {
            name: cardData.name,
            number: cardData.number,
            month: s[0],
            year: s[1],
            type: typeCard(cardData.number),
            cvc: cardData.cvc
        }
        setSession('payment', {code: 'ONLINE', description: 'Pagamento online', online: 'True'})
        setSession('card', card)
        onClick()
    }

    const typeCard = number => {
        try {
            const type = creditCardType(number)
            return type[0].type
        } catch (e) {
            return ''
        } finally {

        }
    }

    const handleCloseSnackbar = () => setSnackbar({open: false})

    useEffect(() => {
        checkCurrentCard()
    }, [])

    const checkCurrentCard = () => {
        const card = getSession('card', {})
        if (!isEmpty(card)) {
            setCardData({
                name: card.name,
                number: card.number,
                expiry: [card.month, card.year].join('/'),
                cvc: card.cvc
            })
        }
    }

    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'add-card'}>
            <div className={'container-add-cart'}>
                <Cards
                    name={cardData.name}
                    number={cardData.number}
                    expiry={cardData.expiry}
                    cvc={cardData.cvc}
                />
                <div className={'div-inputs'}>
                    <Box marginBottom={2}>
                        <TextField
                            focused={true}
                            name={'name'}
                            value={cardData.name}
                            label={textsGeneral.name}
                            placeholder={'TELMO'}
                            variant={'outlined'}
                            color={'secondary'}
                            fullWidth={true}
                            onChange={handleInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') handleConfirm()
                            }}
                        />
                    </Box>
                    <Box marginBottom={2}>
                        <TextField
                            focused={true}
                            type={'tel'}
                            name={'number'}
                            value={cardData.number}
                            label={textsGeneral.number}
                            placeholder={'0000 0000 0000 0000'}
                            variant={'outlined'}
                            color={'secondary'}
                            fullWidth={true}
                            onChange={handleInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') handleConfirm()
                            }}
                        />
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection={'row'}>
                        <TextField
                            focused={true}
                            type={'tel'}
                            name={'expiry'}
                            value={cardData.expiry}
                            label={textsGeneral.expiry}
                            placeholder={'00/00'}
                            variant={'outlined'}
                            color={'secondary'}
                            fullWidth={true}
                            onChange={handleInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') handleConfirm()
                            }}
                        />
                        <Box p={1}/>
                        <TextField
                            focused={true}
                            type={'tel'}
                            name={'cvc'}
                            value={cardData.cvc}
                            label={'CVC'}
                            placeholder={'123'}
                            variant={'outlined'}
                            color={'secondary'}
                            fullWidth={true}
                            onChange={handleInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') handleConfirm()
                            }}
                        />
                    </Box>
                </div>
                <Button
                    className={'button-confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => handleConfirm()}
                />
            </div>
            <>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={1600}
                    onClose={handleCloseSnackbar}
                    message={snackbar.message}/>
            </>
        </div>
    </motion.div>
}

export default AddCardCredit
